import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideCharts, withDefaultRegisterables } from "ng2-charts";
import { defineLocale } from "ngx-bootstrap/chronos";
import * as locales from "ngx-bootstrap/locale";
import { ModalModule } from "ngx-bootstrap/modal";

import { provideFirebaseApp } from "@angular/fire/app";
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFirestoreModule } from "@angular/fire/compat/firestore";
import { AngularFireMessagingModule } from "@angular/fire/compat/messaging";
import { getFirestore, provideFirestore } from "@angular/fire/firestore";
import { Chart, registerables } from "chart.js";
import { initializeApp } from "firebase/app";
import { environment } from "src/environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ToasterComponent } from "./dashboard/shared/toaster/toaster.component";
import { ErrorInterceptor } from "./interceptors/error.interceptor";
import { ModalsModule } from "./modals/modals.module";
import { NotFoundComponent } from "./not-found/not-found.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { ResolversModule } from "./resolvers/resolvers.module";
import { AuthService } from "./services/auth.service";
import { DateService } from "./services/date.service";
import { HttpRequestInterceptor } from "./services/http-interceptor";
import { ModalService } from "./services/modal.service";
import { OverlayService } from "./services/overlay.service";
import { TaskService } from "./services/task.service";
import { TimelineService } from "./services/timeline.service";
import { UserService } from "./services/user.service";
import { StoreModule } from "./store/store.module";
import { TermsOfServiceComponent } from "./terms-of-service/terms-of-service.component";
Chart.register(...registerables);

for (const locale in locales) {
  defineLocale(locales[locale].abbr, locales[locale]);
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    StoreModule,
    ResolversModule,
    ModalModule.forRoot(),
    ModalsModule,
    NotFoundComponent,
    PrivacyPolicyComponent,
    TermsOfServiceComponent,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireMessagingModule,
    AngularFirestoreModule,
    ToasterComponent
  ],
  providers: [
    DateService,
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },
    ModalService,
    OverlayService,
    TaskService,
    TimelineService,
    UserService,
    provideHttpClient(withInterceptorsFromDi()),
    provideCharts(withDefaultRegisterables()),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ]
})
export class AppModule {}
